import { union } from "lodash";

const normalizeId = (id) => (id == null ? id : `${id}`.toLowerCase());

const idsMatch = (left, right) => normalizeId(left) === normalizeId(right);

const getUnitId = (item) => item?.unit?.value;

const getReturnOnInvestmentId = (returnOnInvestment) =>
  returnOnInvestment?.returnOnInvestmentId?.value ??
  returnOnInvestment?.returnOnInvestmentId ??
  returnOnInvestment?.returnOnInvestment?.value ??
  returnOnInvestment?.returnOnInvestment?.id ??
  returnOnInvestment?.value;

const getLookupId = (returnOnInvestment) =>
  returnOnInvestment?.value ??
  returnOnInvestment?.returnOnInvestmentId ??
  returnOnInvestment?.id;

const hasReturnOnInvestmentId = (returnOnInvestmentIds, returnOnInvestmentId) =>
  returnOnInvestmentIds.some((id) => idsMatch(id, returnOnInvestmentId));

const addReturnOnInvestmentId = (returnOnInvestmentIds, returnOnInvestment) => {
  const returnOnInvestmentId = getReturnOnInvestmentId(returnOnInvestment);
  if (
    returnOnInvestmentId == null ||
    hasReturnOnInvestmentId(returnOnInvestmentIds, returnOnInvestmentId)
  ) {
    return;
  }

  returnOnInvestmentIds.push(returnOnInvestmentId);
};

const dedupeReturnOnInvestments = (returnOnInvestments = []) => {
  const returnOnInvestmentIds = [];

  return returnOnInvestments.filter((returnOnInvestment) => {
    const returnOnInvestmentId = getReturnOnInvestmentId(returnOnInvestment);

    if (returnOnInvestmentId == null) return true;
    if (hasReturnOnInvestmentId(returnOnInvestmentIds, returnOnInvestmentId)) {
      return false;
    }

    returnOnInvestmentIds.push(returnOnInvestmentId);
    return true;
  });
};

export const addDefaultReturnOnInvestments = (
  newSheetData,
  returnOnInvestmentData,
  oldSheetData = {},
) => {
  const oldItemsById = (oldSheetData.systemScheduleItems || []).reduce(
    (items, item) => ({
      ...items,
      [item.id]: item,
    }),
    {},
  );

  const addedOrChangedUnitIds = union(
    (newSheetData.systemScheduleItems || [])
      .filter((item) => {
        const unitId = getUnitId(item);
        if (!unitId) return false;

        const oldItem = oldItemsById[item.id];
        return !oldItem || !idsMatch(getUnitId(oldItem), unitId);
      })
      .map(getUnitId),
  );

  if (!addedOrChangedUnitIds.length) return;

  newSheetData.returnOnInvestments = dedupeReturnOnInvestments(
    newSheetData.returnOnInvestments,
  );
  const activeReturnOnInvestmentIds = [];
  (oldSheetData.returnOnInvestments || []).forEach((returnOnInvestment) =>
    addReturnOnInvestmentId(activeReturnOnInvestmentIds, returnOnInvestment),
  );
  (newSheetData.returnOnInvestments || []).forEach((returnOnInvestment) =>
    addReturnOnInvestmentId(activeReturnOnInvestmentIds, returnOnInvestment),
  );

  (returnOnInvestmentData || []).forEach((returnOnInvestment) => {
    const returnOnInvestmentId = getLookupId(returnOnInvestment);

    if (
      returnOnInvestmentId == null ||
      hasReturnOnInvestmentId(activeReturnOnInvestmentIds, returnOnInvestmentId)
    ) {
      return;
    }

    const shouldAdd =
      returnOnInvestment.availableToSheet &&
      returnOnInvestment.defaultOnSheetView &&
      (returnOnInvestment.meteredServiceIds || []).some((meteredServiceId) =>
        addedOrChangedUnitIds.some((unitId) =>
          idsMatch(unitId, meteredServiceId),
        ),
      );

    if (!shouldAdd) return;

    activeReturnOnInvestmentIds.push(returnOnInvestmentId);
    newSheetData.returnOnInvestments.push({
      id: `new_${Date.now()}_${returnOnInvestmentId}`,
      returnOnInvestmentId,
      name: returnOnInvestment.name || returnOnInvestment.text || "",
      showInCustomerView: !!returnOnInvestment.defaultOnCustomerView,
      includeInSnapshot: false,
    });
  });
};
